import { LegalLayout } from './LegalLayout';

export function CookiesPage() {
  return (
    <LegalLayout title="Cookie Notice" lastUpdated="2026-04-22">
      <p className="lead">
        Praxara uses a minimum of cookies and browser storage to operate the
        Service. This notice lists them all and explains their purpose.
      </p>

      <h2>Strictly necessary (always on)</h2>
      <table className="legal-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Purpose</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>praxara.auth</code></td>
            <td>localStorage</td>
            <td>Holds the access + refresh tokens after sign-in. Without this, you cannot stay signed in.</td>
            <td>Until sign-out</td>
          </tr>
          <tr>
            <td><code>praxara.theme</code></td>
            <td>localStorage</td>
            <td>Remembers light/dark theme + sidebar collapsed state.</td>
            <td>Persistent</td>
          </tr>
        </tbody>
      </table>

      <h2>Analytics (consent required)</h2>
      <p>
        We do not run Google Analytics, Meta pixels, or any other cross-site
        tracker. If Sentry session replay is enabled for error diagnostics,
        all text content is masked and media is blocked — Sentry sees only
        DOM structure + errors, never clinical data.
      </p>

      <h2>Third-party cookies</h2>
      <p>
        When you visit a page that embeds Stripe Checkout, Stripe will set
        its own cookies — see{' '}
        <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer">
          stripe.com/privacy
        </a>.
      </p>

      <h2>Managing cookies</h2>
      <p>
        You can clear Praxara cookies + localStorage via your browser's site
        data controls. Doing so will sign you out and reset your theme preferences.
      </p>
    </LegalLayout>
  );
}
